module.exports = __webpack_public_path__ + "img/image7.2df7e4ac.png";